import { SofaConfiguration, ShoppingItem, PredefinedConfiguration } from 'sofa-reborn-react';
import {
	SET_SHOPPING_ITEMS,
	SET_SOFA_CONFIGURATION,
	SET_SELECTED_CONFIGURATION,
	SET_MISSING_CONFIGURATION,
	SET_PERSISTED_CONFIGURATION,
	SofaConfigurationActions,
	SET_PREDEFINED_CONFIGURATION_ID,
	SET_GALLERY_PREDEFINED_CONFIGURATION_ID,
	SET_UPDATE_PREDEFINED_CONFIGURATION,
	SET_GALLERY_VPC_CODE,
	SET_CLOSE_GALLERY,
	SET_MISSING_DEEPLINK,
} from './types';

export function setSofaConfiguration(value: SofaConfiguration): SofaConfigurationActions {
	return {
		type: SET_SOFA_CONFIGURATION,
		value,
	};
}

export function setSelectedConfiguration(value: PredefinedConfiguration): SofaConfigurationActions {
	return {
		type: SET_SELECTED_CONFIGURATION,
		value,
	};
}

export function setMissingConfiguration(
	value: PredefinedConfiguration | null
): SofaConfigurationActions {
	return {
		type: SET_MISSING_CONFIGURATION,
		value,
	};
}

export function setPersistedConfiguration(value: string | null): SofaConfigurationActions {
	return {
		type: SET_PERSISTED_CONFIGURATION,
		value,
	};
}

export function setShoppingItems(value: ShoppingItem[]): SofaConfigurationActions {
	return {
		type: SET_SHOPPING_ITEMS,
		value,
	};
}

export function setPredefinedConfigurationId(value: string | null): SofaConfigurationActions {
	return { type: SET_PREDEFINED_CONFIGURATION_ID, value };
}

export function setGalleryPredefinedConfigurationId(value: string): SofaConfigurationActions {
	return { type: SET_GALLERY_PREDEFINED_CONFIGURATION_ID, value };
}

export function setUpdatePredefinedConfiguration(value: boolean): SofaConfigurationActions {
	return { type: SET_UPDATE_PREDEFINED_CONFIGURATION, value };
}

export function setGalleryVpcCode(): SofaConfigurationActions {
	return {
		type: SET_GALLERY_VPC_CODE,
	};
}

export function setCloseGallery(value: string): SofaConfigurationActions {
	return {
		type: SET_CLOSE_GALLERY,
		value,
	};
}

export function setMissingDeeplink(value: string | null): SofaConfigurationActions {
	return {
		type: SET_MISSING_DEEPLINK,
		value,
	};
}
